import { useEffect } from "react";
import { useSearchParams } from "react-router";

import { setLocalStorageItem } from "~/lib/localStorage";
import removeEmptyObjectKeys from "~/util/removeEmptyObjectKeys";

interface CampaignParams {
  utm_campaign?: string | null;
  utm_source?: string | null;
  utm_medium?: string | null;
  utm_content?: string | null;
  utm_term?: string | null;
  gclid?: string | null;
  msclkid?: string | null;
}

/**
 * Hook to capture campaign parameters from URL and store them in localStorage
 * Captures UTM parameters and ad tracking IDs (gclid, msclkid)
 * If there are newer params in the URL, overwrite the preexisting params
 */
const useCampaignParams = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const campaignParams: CampaignParams = {
      utm_campaign: searchParams.get("utm_campaign"),
      utm_source: searchParams.get("utm_source"),
      utm_medium: searchParams.get("utm_medium"),
      utm_content: searchParams.get("utm_content"),
      utm_term: searchParams.get("utm_term"),
      gclid: searchParams.get("gclid"),
      msclkid: searchParams.get("msclkid"),
    };

    const hasParams = Object.values(campaignParams).some(
      (value) => value !== null
    );

    if (hasParams) {
      const cleanedParams = removeEmptyObjectKeys(campaignParams);
      setLocalStorageItem("campaignParams", cleanedParams);
    }
  }, [searchParams]);
};

export default useCampaignParams;
